import { horizontalScrollablePanelBoughtThisSeason } from './horizontal-scrollable-panel-bought-this-season';
import { horizontalScrollablePanelBestPerformingArticles } from './horizontal-scrollable-panel-best-performing-articles';

export const brooks = {
  horizontalScrollablePanelBestPerformingArticles,
  horizontalScrollablePanelBoughtThisSeason,
};
